export class UnlockLoginRequest {
    MemberID: number;
}
